/* eslint-disable @typescript-eslint/no-unused-vars */
import { styled } from "@mui/material";
import TimerDisplay from "./lib/TimerDisplay";
import { TimerIcon } from "../../utils/svgIcons";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./styles.module.scss";
import { Moment } from "moment";
import classNames from "classnames";
import { CSSProperties } from "styled-components";
import { useState } from "react";

const TimerBox = styled("div")(({ theme }) => ({
	// [theme.breakpoints.down("featCardImg")]: {
	// 	fontSize: "0.9em"
	// }
}));

const CountdownV3 = ({
	text = "Ends in:",
	startTime,
	endTime,
	onEnd,
	status,
	labelStyle,
	style,
	hideTimerDisplayOnEnd
}: {
	text?: string;
	startTime: Moment | null;
	endTime: string;
	icon?: JSX.Element;
	onEnd: () => void;
	status?: string;
	labelStyle?: CSSProperties;
	style?: CSSProperties;
	iconStyle?: CSSProperties;
	className?: string;
	hideTimerDisplayOnEnd?: boolean;
}) => {
	const [showTimerDisplay, setShowTimerDisplay] = useState<boolean>(true);
	return (
		<TimerBox style={style}>
			<div style={labelStyle}>{text}</div>
			{showTimerDisplay && (
				<TimerDisplay
					startTime={startTime}
					endTime={endTime}
					status={status}
					onEnd={() => {
						onEnd();
						hideTimerDisplayOnEnd && setShowTimerDisplay(false);
					}}
				/>
			)}
		</TimerBox>
	);
};

export default CountdownV3;
